import {VNode} from "./vnode";
const {forEach, all} = require("../core/collections");
const {isVal, hasField, isStr, isArr, isFun, isNum} = require("../core/types");
const JSS = require("./jss")

function randomId() {
    return (Date.now().toString(24).slice(2)+ Math.random().toString(24).slice(6))
}

function isComponent(node) {
    return isFun(node.render)
}

function isStatic(node) {
    if (!isComponent(node)) {
        return all(node.nodes, (n)=>isStatic(n))
    } else return false
}

function isEventPropKey(key) {
    return /on[A-Z]+/.test(key)
}

function normalizeEventName(eventName) {
    return eventName.slice(2).toLowerCase()
}

function compileProps(props) {
    const cats = {
        events: {},
        attrs: {}
    }
    forEach(props, (v, k)=>{
        if (isEventPropKey(k))
            cats.events[normalizeEventName(k)] = v
        else
            cats.attrs[k] = v
    })
    return cats
}

function compileStyles(styles, joinWith) {
    if (!isVal(styles)) return ''
    else if (isStr(styles)) return styles
    else if (isArr(styles)) return styles.join(joinWith)
    return JSS.generateCss(styles, joinWith)
}

function sameClass(t1, t2) {
    let name1 = t1.constructor.name
    let name2 = t2.name
    if (hasField(t1, 'prototype')) {
        name1 = t1.prototype.constructor.name
    }
    if (hasField(t2, 'prototype')) {
        name2 = t2.prototype.constructor.name
    }
    console.log(name1, name2)
    return name1 === name2
}

function instanceOf(inst, cls) {
    const instProto = Object.getPrototypeOf(inst)
    const classProto = cls.prototype
    // console.log(instProto, classProto)
    return instProto.constructor.name === classProto.constructor.name
}

function isChildOf(child, parent) {
    const parentProto = parent.prototype || Object.getPrototypeOf(parent)
    const parentName = parentProto.constructor.name
    let childProto = child.prototype || Object.getPrototypeOf(child)
    while (childProto) {
        if (childProto.name === parentName || childProto.constructor.name === parentName) return true
        childProto = Object.getPrototypeOf(childProto)
    }
    return false
}

function renameFunc(fn, name) {
    return new Function("fn", `return function ${name}() {return fn.apply(this, arguments)}`)(fn)
}

function copyPrototype(thing) {
    let props = Object.getOwnPropertyDescriptors(thing);
    let copied = Object.create({})
    Object.defineProperties(copied, props)
    console.log(copied)
    return copied
}

function flattenChildren(children) {
    const flat = []
    const len = children.length
    for (let i=0; i<len; i++) {
        let child = children[i]
        if (child.constructor.name === 'Array') {
            const clen = child.length
            for (let j=0; j<clen; j++) {
                let ch = child[j]
                if (isStr(ch) || isNum(ch)) {
                    ch = VNode.createText(ch.toString())
                }
                flat.push(ch)
            }
        } else {
            if (isStr(child) || isNum(child)) {
                child = VNode.createText(child.toString())
            }
            flat.push(child)
        }
    }
    return flat
}

function swapChildNodes(parent, nodes, newIndex, currentIndex) {
    parent.insertBefore(nodes[newIndex], nodes[currentIndex])
}

function substituteTextNodes(children) {
    return children.map((ch) => {
        if (isStr(ch) || isNum(ch)) {
            return VNode.createText(ch.toString())
        } else return ch
    })
}

module.exports = {
    randomId,
    compileProps,
    compileStyles,
    isComponent,
    isStatic,
    isEventPropKey,
    normalizeEventName,
    sameClass,
    isChildOf,
    instanceOf,
    renameFunc,
    copyPrototype,
    flattenChildren,
    swapChildNodes,
    substituteTextNodes
}